export default {
    actions: {
        turnOff({ commit }) {
            commit("TOGGLE_LOADING", false);
        },
        turnOn({ commit }) {
            commit("TOGGLE_LOADING", true);
        },
        keepOff({ commit }) {
            commit("KEEP_OFF");
        },
        keepReset({ commit }) {
            commit("KEEP_RESET");
        },
    },
    getters: {
        processing(state) {
            return state.loading;
        },
    },
    mutations: {
        TOGGLE_LOADING(state, payload) {
            if (!state.keepOff) {
                state.loading = payload;
            }
        },

        KEEP_OFF(state) {
            state.keepOff = true;
        },

        KEEP_RESET(state) {
            state.keepOff = null;
        },
    },
    namespaced: true,
    state: {
        loading: false,
        keepOff: null,
    },
};
